import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IBeautyGuideResource } from 'src/shared/models/beautyGuideResource.model';

const {
  BEAUTY_GUIDE_BUTTON_LABEL,
  BEAUTY_GUIDE_DESCRIPTION,
  BEAUTY_GUIDE_IMAGE,
} = ResourceTypeDetailEnum;

export const buildBeautyGuide = (
  resource: IResourceList
): IBeautyGuideResource => {
  const { resourceDetailList, name: title, idResource, score } = resource;
  let item: IBeautyGuideResource;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case BEAUTY_GUIDE_BUTTON_LABEL:
          item = {
            ...item,
            buttonName: value,
          };
          break;
        case BEAUTY_GUIDE_IMAGE:
          item = {
            ...item,
            image: value,
          };
          break;
        case BEAUTY_GUIDE_DESCRIPTION:
          item = { ...item, text: value };
          break;
      }
    });

  return {
    ...item,
    title,
    idResource,
    points: score?.points || 0,
  };
};
